import { ref, computed } from 'vue'

const currentYear = ref(new Date().getFullYear())

export const useYearSelector = () => {
  const nextYear = () => {
    currentYear.value = currentYear.value + 1
  }

  const prevYear = () => {
    currentYear.value = currentYear.value - 1
  }

  const resetYear = () => {
    currentYear.value = new Date()
    currentYear.value.setMonth(currentYear.value.getMonth() - 3)
    currentYear.value = currentYear.value.getFullYear()
  }

  const wareki = computed(() => {
    const opt = { year: 'numeric', month: 'long', day: 'numeric' }
    return (
      new Date(currentYear.value, 1, 1)
        .toLocaleDateString('ja-JP-u-ca-japanese', opt)
        .split('年')[0] + '年度'
    )
  })

  return { currentYear, wareki, nextYear, prevYear, resetYear }
}
